export default function StatCard({ label, value, caption, tone = "blue" }) {
  const tones = { blue: "border-[#002FA7]", green: "border-emerald-500", yellow: "border-yellow-400", red: "border-red-500" };
  const slug = label.toLowerCase().replaceAll(" ", "-").normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return (
    <div className={`border-l-4 bg-white p-5 ${tones[tone]} border-y border-r border-zinc-200 stagger-in`} data-testid={`stat-card-${slug}`}>
      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-zinc-500" data-testid={`stat-card-${slug}-label`}>{label}</p>
      <p className="mt-3 font-display text-4xl font-bold" data-testid={`stat-card-${slug}-value`}>{value}</p>
      <p className="mt-2 text-sm text-zinc-500" data-testid={`stat-card-${slug}-caption`}>{caption}</p>
    </div>
  );
}